import { GHLLanguageKeys as e } from "./ghl-ui.es285.js";
const t = {
  name: e.frenchCanada,
  global: {
    undo: "Annuler",
    redo: "Rétablir",
    confirm: "Confirmer",
    clear: "Effacer",
    more: "plus",
    cancel: "Annuler"
  },
  Popconfirm: {
    positiveText: "Confirmer",
    negativeText: "Effacer"
  },
  Cascader: {
    placeholder: "Veuillez sélectionner",
    loading: "Chargement",
    loadingRequiredMessage: () => null
  },
  Time: {
    dateFormat: "dd/MM/yyyy",
    dateTimeFormat: "dd/MM/yyyy HH:mm:ss"
  },
  DatePicker: {
    yearFormat: "yyyy",
    monthFormat: "MMM",
    dayFormat: "eeeeee",
    yearTypeFormat: "yyyy",
    monthTypeFormat: "MM/yyyy",
    dateFormat: "dd/MM/yyyy",
    dateTimeFormat: "dd/MM/yyyy HH:mm:ss",
    quarterFormat: "qqq yyyy",
    clear: "Effacer",
    now: "Maintenant",
    confirm: "Confirmer",
    selectTime: "Sélectionner l'heure",
    selectDate: "Sélectionner la date",
    datePlaceholder: "Sélectionner une date",
    datetimePlaceholder: "Sélectionner la date et l'heure",
    monthPlaceholder: "Sélectionner le mois",
    yearPlaceholder: "Sélectionner l'année",
    quarterPlaceholder: "Sélectionner le trimestre",
    startDatePlaceholder: "Date de début",
    endDatePlaceholder: "Date de fin",
    startDatetimePlaceholder: "Date et heure de début",
    endDatetimePlaceholder: "Date et heure de fin",
    startMonthPlaceholder: "Mois de début",
    endMonthPlaceholder: "Mois de fin",
    monthBeforeYear: !0,
    firstDayOfWeek: 1,
    today: "Aujourd'hui"
  },
  DataTable: {
    checkTableAll: "Sélectionner tout dans le tableau",
    uncheckTableAll: "Déselectionner tout dans le tableau",
    confirm: "Confirmer",
    clear: "Effacer",
    apply: "Appliquer",
    filters: "Filtres",
    sort: "Trier"
  },
  LegacyTransfer: {
    sourceTitle: "Source",
    targetTitle: "Cible"
  },
  Transfer: {
    selectAll: "Tout sélectionner",
    unselectAll: "Tout désélectionner",
    clearAll: "Effacer"
  },
  Empty: {
    description: "Aucune donnée"
  },
  Select: {
    placeholder: "Veuillez sélectionner"
  },
  TimePicker: {
    placeholder: "Sélectionner l'heure",
    positiveText: "OK",
    negativeText: "Annuler",
    now: "Maintenant"
  },
  Pagination: {
    goto: "Aller à",
    selectionSuffix: "page",
    next: "Suivant",
    previous: "Précédent"
  },
  DynamicTags: {
    add: "Ajouter"
  },
  Log: {
    loading: "Chargement"
  },
  Input: {
    placeholder: "Veuillez entrer"
  },
  InputNumber: {
    placeholder: "Veuillez entrer"
  },
  DynamicInput: {
    create: "Créer"
  },
  ThemeEditor: {
    title: "Éditeur de thème",
    clearAllVars: "Effacer toutes les variables",
    clearSearch: "Effacer la recherche",
    filterCompName: "Filtrer le nom du composant",
    filterVarName: "Filtrer le nom de la variable",
    import: "Importer",
    export: "Exporter",
    restore: "Réinitialiser par défaut"
  },
  Image: {
    tipPrevious: "Image précédente (←)",
    tipNext: "Image suivante (→)",
    tipCounterclockwise: "Dans le sens antihoraire",
    tipClockwise: "Dans le sens horaire",
    tipZoomOut: "Zoom arrière",
    tipZoomIn: "Zoom avant",
    tipClose: "Fermer (Esc)",
    tipOriginalSize: "Zoom à la taille d'origine"
  },
  SortFilter: {
    heading: "Trier et filtrer",
    sortHeading: "Trier par",
    newestFirst: "Plus récent en premier",
    oldestFirst: "Plus ancien en premier",
    ascending: "Croissant",
    descending: "Décroissant",
    aToZ: "A-Z",
    zToA: "Z-A",
    apply: "Appliquer",
    clear: "Effacer",
    cancel: "Annuler",
    filters: "Filtres"
  },
  IconPicker: {
    noMatchingFound: "Aucun résultat correspondant trouvé"
  },
  Spacing: {
    margin: "Marge",
    padding: "Rembourrage",
    reset: "Réinitialiser",
    errorMsg: "La valeur fournie est invalide."
  },
  BrandColorPicker: {
    brandColors: "Couleurs de marque",
    noBrandColors: "Vous n'avez pas encore ajouté de couleurs de marque.",
    getStarted: "Commencer",
    add: "Ajouter",
    default: "Par défaut"
  }
};
export {
  t as frCA
};
